import { render, staticRenderFns } from "./ExportLot.vue?vue&type=template&id=63670dd6"
import script from "./ExportLot.vue?vue&type=script&lang=js"
export * from "./ExportLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports